'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _arrify = require('arrify');

var _arrify2 = _interopRequireDefault(_arrify);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _default = (function (_Api) {
	_inherits(_default, _Api);

	function _default() {
		_classCallCheck(this, _default);

		_get(Object.getPrototypeOf(_default.prototype), 'constructor', this).apply(this, arguments);
	}

	_createClass(_default, [{
		key: 'addToCart',
		value: function addToCart(val) {
			this.push({
				event: 'addToCart',
				ecommerce: {
					add: {
						products: (0, _arrify2['default'])(val)
					}
				}
			});
		}
	}, {
		key: 'checkout',
		value: function checkout(val, obj) {
			obj = obj || {};

			var callback = function callback() {
				document.location = obj.url;
			};

			callback = obj.callback || callback;

			this.push({
				event: 'checkout',
				eventCallback: callback,
				ecommerce: {
					checkout: {
						actionField: {
							option: obj.option,
							step: obj.step
						},
						products: (0, _arrify2['default'])(val)
					}
				}
			});
		}
	}, {
		key: 'detail',
		value: function detail(val, obj) {
			obj = obj || {};

			this.push({
				event: 'detail',
				ecommerce: {
					detail: {
						actionField: obj,
						products: (0, _arrify2['default'])(val)
					}
				}
			});
		}
	}, {
		key: 'impression',
		value: function impression(val) {
			this.push({
				event: 'impression',
				ecommerce: {
					impressions: (0, _arrify2['default'])(val)
				}
			});
		}
	}, {
		key: 'pageView',
		value: function pageView(val, opts) {
			var obj = (0, _objectAssign2['default'])({
				url: val
			}, opts);

			this.push({
				event: 'virtualPageView',
				page: obj
			});
		}
	}, {
		key: 'productClick',
		value: function productClick(val, obj) {
			obj = obj || {};

			var callback = function callback() {
				document.location = val.url;
			};

			callback = val.callback || callback;

			delete val.callback;
			delete val.url;

			this.push({
				event: 'productClick',
				eventCallback: callback,
				ecommerce: {
					click: {
						actionField: obj,
						products: (0, _arrify2['default'])(val)
					}
				}
			});
		}
	}, {
		key: 'promotionClick',
		value: function promotionClick(obj) {
			obj = obj || {};

			var callback = function callback() {
				document.location = obj.url;
			};

			callback = obj.callback || callback;

			delete obj.callback;
			delete obj.url;

			this.push({
				event: 'promotionClick',
				eventCallback: callback,
				ecommerce: {
					promoClick: {
						promotions: [{
							'name': obj.name,
							'position': obj.position
						}]
					}
				}
			});
		}
	}, {
		key: 'promotionView',
		value: function promotionView(val) {
			var arr = val.map(function (x, i) {
				return {
					name: x.catname,
					position: i
				};
			});

			this.push({
				event: 'promotionView',
				ecommerce: {
					promoView: {
						promotions: arr
					}
				}
			});
		}
	}, {
		key: 'purchase',
		value: function purchase(val, obj) {
			obj = obj || {};

			this.push({
				event: 'purchase',
				ecommerce: {
					purchase: {
						actionField: obj,
						products: (0, _arrify2['default'])(val)
					}
				}
			});
		}
	}, {
		key: 'removeFromCart',
		value: function removeFromCart(val) {
			this.push({
				event: 'removeFromCart',
				ecommerce: {
					remove: {
						products: (0, _arrify2['default'])(val)
					}
				}
			});
		}
	}]);

	return _default;
})(_api2['default']);

exports['default'] = _default;
module.exports = exports['default'];